'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _containers = require('containers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  /**
   * Rutas en orden alfabético
   */
  return _react2.default.createElement(
    _reactRouter.Route,
    { path: '/', component: _containers.App },
    _react2.default.createElement(
      _reactRouter.Route,
      { path: '/webdocs/guerra-mentira/es/' },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Home }),
      _react2.default.createElement(_reactRouter.Route, { path: 'quien-bombardeo-hogar-omran/', component: _containers.Case, caseId: 'case1' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'quien-derribo-mh17/', component: _containers.Case, caseId: 'case2' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'quien-destruyo-convoy-humanitario/', component: _containers.Case, caseId: 'case3' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'tutoriales/', component: _containers.About }),
      _react2.default.createElement(_reactRouter.Route, { path: 'creditos/', component: _containers.Credits }),
      _react2.default.createElement(_reactRouter.Route, { path: 'quien-hace-estas-verificaciones/', component: _containers.FinalVideo }),
      _react2.default.createElement(_reactRouter.Route, { path: 'documental/', component: _containers.Documentary })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: '/webdocs/guerra-mentira/en/' },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Home }),
      _react2.default.createElement(_reactRouter.Route, { path: 'who-bombed-omran-home/', component: _containers.Case, caseId: 'case1' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'who-downed-mh17/', component: _containers.Case, caseId: 'case2' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'who-destroyed-the-humanitarian-convoy/', component: _containers.Case, caseId: 'case3' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'tutorials/', component: _containers.About }),
      _react2.default.createElement(_reactRouter.Route, { path: 'credits/', component: _containers.Credits }),
      _react2.default.createElement(_reactRouter.Route, { path: 'who-verified-internationtal-wars/', component: _containers.FinalVideo }),
      _react2.default.createElement(_reactRouter.Route, { path: 'documentary/', component: _containers.Documentary })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'es/' },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Home }),
      _react2.default.createElement(_reactRouter.Route, { path: 'quien-bombardeo-hogar-omran/', component: _containers.Case, caseId: 'case1' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'quien-derribo-mh17/', component: _containers.Case, caseId: 'case2' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'quien-destruyo-convoy-humanitario/', component: _containers.Case, caseId: 'case3' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'tutoriales/', component: _containers.About }),
      _react2.default.createElement(_reactRouter.Route, { path: 'creditos/', component: _containers.Credits }),
      _react2.default.createElement(_reactRouter.Route, { path: 'quien-hace-estas-verificaciones/', component: _containers.FinalVideo }),
      _react2.default.createElement(_reactRouter.Route, { path: 'documental/', component: _containers.Documentary })
    ),
    _react2.default.createElement(
      _reactRouter.Route,
      { path: 'en/' },
      _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Home }),
      _react2.default.createElement(_reactRouter.Route, { path: 'who-bombed-omran-home/', component: _containers.Case, caseId: 'case1' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'who-downed-mh17/', component: _containers.Case, caseId: 'case2' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'who-destroyed-the-humanitarian-convoy/', component: _containers.Case, caseId: 'case3' }),
      _react2.default.createElement(_reactRouter.Route, { path: 'tutorials/', component: _containers.About }),
      _react2.default.createElement(_reactRouter.Route, { path: 'credits/', component: _containers.Credits }),
      _react2.default.createElement(_reactRouter.Route, { path: 'who-verified-internationtal-wars/', component: _containers.FinalVideo }),
      _react2.default.createElement(_reactRouter.Route, { path: 'documentary/', component: _containers.Documentary })
    ),
    _react2.default.createElement(_reactRouter.IndexRoute, { component: _containers.Home }),
    _react2.default.createElement(_reactRouter.Route, { path: 'quien-bombardeo-hogar-omran/', component: _containers.Case, caseId: 'case1' }),
    _react2.default.createElement(_reactRouter.Route, { path: 'quien-derribo-mh17/', component: _containers.Case, caseId: 'case2' }),
    _react2.default.createElement(_reactRouter.Route, { path: 'quien-destruyo-convoy-humanitario/', component: _containers.Case, caseId: 'case3' }),
    _react2.default.createElement(_reactRouter.Route, { path: 'tutoriales/', component: _containers.About }),
    _react2.default.createElement(_reactRouter.Route, { path: 'creditos/', component: _containers.Credits }),
    _react2.default.createElement(_reactRouter.Route, { path: 'quien-hace-estas-verificaciones/', component: _containers.FinalVideo }),
    _react2.default.createElement(_reactRouter.Route, { path: 'documental/', component: _containers.Documentary }),
    _react2.default.createElement(_reactRouter.Route, { path: 'who-bombed-omran-home/', component: _containers.Case, caseId: 'case1' }),
    _react2.default.createElement(_reactRouter.Route, { path: 'who-downed-mh17/', component: _containers.Case, caseId: 'case2' }),
    _react2.default.createElement(_reactRouter.Route, { path: 'who-destroyed-the-humanitarian-convoy/', component: _containers.Case, caseId: 'case3' }),
    _react2.default.createElement(_reactRouter.Route, { path: 'tutorials/', component: _containers.About }),
    _react2.default.createElement(_reactRouter.Route, { path: 'credits/', component: _containers.Credits }),
    _react2.default.createElement(_reactRouter.Route, { path: 'who-verified-internationtal-wars/', component: _containers.FinalVideo }),
    _react2.default.createElement(_reactRouter.Route, { path: 'documentary/', component: _containers.Documentary }),
    _react2.default.createElement(_reactRouter.Route, { path: '*', component: _containers.NotFound, status: 404 })
  );
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 826
// module chunks = 0